import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateAnnouncement=(statement,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_ANNOUNCEMENT_START
    })
    const options={
        url:`${api}/announcements`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{statement}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_ANNOUNCEMENT_FAIL,
                payload:getMessage(error)
            }))
}